import { motion } from "framer-motion";

const P = (lon, lat) => [((lon - 20) * 62).toFixed(1), ((48.4 - lat) * 88).toFixed(1)];
const OUTLINE = [
  [20.26, 46.11], [21.1, 46.35], [21.6, 46.95], [22.0, 47.45], [22.6, 47.75], [22.9, 47.97], [23.5, 48.0], [24.6, 47.95],
  [25.2, 47.88], [26.2, 48.0], [26.65, 48.27], [27.3, 47.75], [27.75, 47.3], [28.1, 46.95], [28.2, 46.4], [28.1, 45.75],
  [28.2, 45.47], [28.7, 45.25], [29.6, 45.35], [29.7, 45.05], [29.6, 44.8], [28.95, 44.6], [28.6, 43.75], [27.95, 43.98],
  [27.0, 44.15], [26.1, 43.98], [25.3, 43.65], [24.4, 43.72], [23.3, 43.85], [22.9, 43.95], [22.5, 44.45], [22.0, 44.6],
  [21.4, 44.8], [21.45, 45.15], [20.8, 45.5],
].map(([a, b]) => P(a, b).join(",")).join(" ");

const CITIES = [
  ["Timișoara", 21.23, 45.75], ["Cluj-Napoca", 23.6, 46.77], ["Sibiu", 24.15, 45.79], ["Craiova", 23.8, 44.32],
  ["Brașov", 25.6, 45.65], ["București", 26.1, 44.43], ["Iași", 27.6, 47.16], ["Constanța", 28.65, 44.17], ["Oradea", 21.92, 47.05],
];
const PRIMARY = [["Deva", 22.9, 45.88], ["Hunedoara", 22.9, 45.75], ["Târgu Jiu", 23.27, 45.04], ["Lupeni", 23.23, 45.36]];
const HQ = P(23.37, 45.41);

export const RomaniaMap = () => (
  <svg viewBox="0 0 620 420" className="w-full h-auto" data-testid="coverage-map" role="img" aria-label="Romania coverage map">
    <defs>
      <radialGradient id="zone" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#DC2626" stopOpacity="0.45" />
        <stop offset="100%" stopColor="#DC2626" stopOpacity="0" />
      </radialGradient>
      <pattern id="dots" width="10" height="10" patternUnits="userSpaceOnUse"><circle cx="1.5" cy="1.5" r="1.1" fill="#3f3f46" /></pattern>
    </defs>
    <motion.polygon points={OUTLINE} fill="url(#dots)" stroke="#71717a" strokeWidth="1.2" initial={{ pathLength: 0, opacity: 0 }} whileInView={{ pathLength: 1, opacity: 1 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 2 }} />
    <circle cx={HQ[0]} cy={HQ[1]} r="95" fill="url(#zone)" />
    {CITIES.map(([n, lon, lat]) => {
      const [x, y] = P(lon, lat);
      return (
        <g key={n}>
          <line x1={HQ[0]} y1={HQ[1]} x2={x} y2={y} stroke="#DC2626" strokeOpacity="0.25" strokeDasharray="3 5" />
          <circle cx={x} cy={y} r="3.5" fill="#a1a1aa" />
          <text x={Number(x) + 7} y={Number(y) + 4} fill="#a1a1aa" fontSize="12" fontFamily="JetBrains Mono">{n}</text>
        </g>
      );
    })}
    {PRIMARY.map(([n, lon, lat]) => {
      const [x, y] = P(lon, lat);
      return <g key={n}><circle cx={x} cy={y} r="4" fill="#ef4444" /><text x={Number(x) - 7} y={Number(y) - 7} textAnchor="end" fill="#fecaca" fontSize="11" fontFamily="JetBrains Mono">{n}</text></g>;
    })}
    <circle cx={HQ[0]} cy={HQ[1]} r="7" fill="#DC2626" className="ping-slow" />
    <circle cx={HQ[0]} cy={HQ[1]} r="7" fill="#DC2626" stroke="#fff" strokeWidth="2" />
    <text x={Number(HQ[0]) + 12} y={Number(HQ[1]) + 18} fill="#fff" fontSize="14" fontWeight="700" fontFamily="JetBrains Mono">PETROȘANI · HQ</text>
  </svg>
);
